import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../environments/environment';
import { SurveyAuthService } from '../../../../shared/survey-auth.service';
import { Choice } from '../models/choice';
import { Question } from '../models/question';

@Injectable()
export class ChoiceService {
  constructor(private http: HttpClient, private auth: SurveyAuthService) {}

  insertChoice(
    question: Question,
    choice: Choice,
    reference_choice: Choice
  ): Observable<any> {
    let post_url = `${environment.surveyApiHost}/api//v1/surveys/${
      question.getSurvey().id
    }/pages/${question.getPage().id}/questions/${question.id}/choices/`;
    if (reference_choice != null) {
      post_url = post_url + `?ref_choice_id=${reference_choice.id}`;
    }
    console.log('POST ' + post_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .post(post_url, choice, { headers: headers })
      .map(this.processPostPutResponse)
      .catch(this.handleError);
  }

  updateChoice(choice: Choice): Observable<any> {
    const put_url = `${environment.surveyApiHost}/api/v1/surveys/${
      choice.getQuestion().getSurvey().id
    }/pages/${choice.getQuestion().getPage().id}/questions/${
      choice.getQuestion().id
    }/choices/${choice.id}/`;
    console.log('PUT ' + put_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);
    console.log('choice: ', choice.toJSON());
    return this.http
      .put(put_url, choice.toJSON(), { headers: headers })
      .catch(this.handleError);
  }

  deleteChoice(choice: Choice): Observable<any> {
    const delete_url = `${environment.surveyApiHost}/api/v1/surveys/${
      choice.getQuestion().getSurvey().id
    }/pages/${choice.getQuestion().getPage().id}/questions/${
      choice.getQuestion().id
    }/choices/${choice.id}/`;
    console.log('DELETE ' + delete_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .delete(delete_url, { headers: headers })
      .catch(this.handleError);
  }

  moveChoice(choice: Choice, new_order: number): Observable<any> {
    let get_url = `${environment.surveyApiHost}/api/v1/surveys/${
      choice.getQuestion().getPage().getSurvey().id
    }/pages/${choice.getQuestion().getPage().id}/questions/${
      choice.getQuestion().id
    }/choices/${choice.id}/move`;
    if (new_order != null) {
      get_url = get_url + `?new_order=${new_order}`;
    }
    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http.get(get_url, { headers: headers }).catch(this.handleError);
  }

  private processPostPutResponse(res: HttpResponse<any>): Choice {
    console.log('processPostResponse: res: ', res);
    const body = res.body.json();
    console.log('processResponse: body: ', body);
    const choice: Choice = Object.create(Choice.prototype);
    const obj = Object.assign(choice, body, {});
    return obj || {};
  }

  private handleError(error: HttpResponse<any> | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpResponse) {
      const body = error.body.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
